import script from "./j-text3.vue?vue&type=script&lang=ts&setup=true"
export * from "./j-text3.vue?vue&type=script&lang=ts&setup=true"

import "./j-text3.vue?vue&type=style&index=0&id=7df823ec&lang=less&scoped=true"

import exportComponent from "/root/djmesweb-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7df823ec"]])

export default __exports__